export default function init(handler) {
  handler.mock.onGet(/\/v1\/cart/, { params: { store: 2 } }).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        cart: [
          {
            active: true,
            client_id: null,
            count: 2,
            created_at: "2019-03-09T12:24:07.3545168+03:30",
            customer_id: "c47a8c6f-a649-4dbb-b7fd-af917983ebff",
            deleted_at: null,
            id: "6770145a-df8d-4ba1-9059-5199f9316c05",
            order_id: null,
            product_id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
            updated_at: "2019-03-09T12:24:10.2636978+03:30",
            product: {
              active: true,
              all_barcode: "4712702618785;",
              app_name: "میکرو رم 16 گیگ کلاس 10",
              barcode: "4712702618785",
              brand: "سیلیکون",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
              created_at: "2018-12-12T18:33:27.237578+03:30",
              current_discount: 20,
              current_price: 750000,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "توضیحات↵بعاد↵1 × 11 × 15 میلی‌متر↵ظرفیت↵16 گیگابایت↵استاندارد سرعت↵Class 10 , UHS-I U1↵سرعت خواندن↵40 مگابایت در ثانیه↵سرعت نوشتن↵15 مگابایت در ثانیه↵مقاوم در برابر↵ضربه↵سایر مشخصات↵- به همراه آداپتور SD",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "",
              gallery: null,
              height: 0,
              id: 1,
              language_id: 314,
              last_price: 680000,
              name: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              name_in_pos: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 2,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2019-01-25T18:36:17.6790904+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T18:31:50.3510175+03:30",
                deleted_at: null,
                description: "",
                id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
                title: "4712702618785",
                updated_at: "2018-12-12T18:31:50.3510175+03:30",
                url: "http://cs123.ir:27907/assets/images/652d936d-44e5-47d6-b264-bb0788b05fd7.png",
              }
            }
          },
          {
            active: true,
            client_id: null,
            count: 2,
            created_at: "2019-03-09T12:24:07.3545168+03:30",
            customer_id: "c47a8c6f-a649-4dbb-b7fd-af917983ebff",
            deleted_at: null,
            id: "6770145a-df8d-4ba1-9059-5199f9316c0533",
            order_id: null,
            product_id: "2cbb38ab-3190-42b1-b015-e6645b768841111",
            updated_at: "2019-03-09T12:24:10.2636978+03:30",
            product: {
              active: true,
              all_barcode: "4712702618785;",
              app_name: "میکرو رم 16 گیگ کلاس 10",
              barcode: "4712702618785",
              brand: "سیلیکون",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
              created_at: "2018-12-12T18:33:27.237578+03:30",
              current_discount: 20,
              current_price: 750000,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "توضیحات↵بعاد↵1 × 11 × 15 میلی‌متر↵ظرفیت↵16 گیگابایت↵استاندارد سرعت↵Class 10 , UHS-I U1↵سرعت خواندن↵40 مگابایت در ثانیه↵سرعت نوشتن↵15 مگابایت در ثانیه↵مقاوم در برابر↵ضربه↵سایر مشخصات↵- به همراه آداپتور SD",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "",
              gallery: null,
              height: 0,
              id: "2cbb38ab-3190-42b1-b015-e6645b768841111",
              language_id: 314,
              last_price: 680000,
              name: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              name_in_pos: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 5,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2019-01-25T18:36:17.6790904+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T18:31:50.3510175+03:30",
                deleted_at: null,
                description: "",
                id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
                title: "4712702618785",
                updated_at: "2018-12-12T18:31:50.3510175+03:30",
                url: "http://cs123.ir:27907/assets/images/652d936d-44e5-47d6-b264-bb0788b05fd7.png",
              }
            }
          },
        ]
      },
      meta: {
        store: 2
      }
    })
  )

  handler.mock.onPut(/\/v1\/cart/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        cart: [
          {
            active: true,
            client_id: null,
            count: 2,
            created_at: "2019-03-09T12:24:07.3545168+03:30",
            customer_id: "c47a8c6f-a649-4dbb-b7fd-af917983ebff",
            deleted_at: null,
            id: "6770145a-df8d-4ba1-9059-5199f9316c05",
            order_id: null,
            product_id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
            updated_at: "2019-03-09T12:24:10.2636978+03:30",
            product: {
              active: true,
              all_barcode: "4712702618785;",
              app_name: "میکرو رم 16 گیگ کلاس 10",
              barcode: "4712702618785",
              brand: "سیلیکون",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
              created_at: "2018-12-12T18:33:27.237578+03:30",
              current_discount: 20,
              current_price: 750000,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "توضیحات↵بعاد↵1 × 11 × 15 میلی‌متر↵ظرفیت↵16 گیگابایت↵استاندارد سرعت↵Class 10 , UHS-I U1↵سرعت خواندن↵40 مگابایت در ثانیه↵سرعت نوشتن↵15 مگابایت در ثانیه↵مقاوم در برابر↵ضربه↵سایر مشخصات↵- به همراه آداپتور SD",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "",
              gallery: null,
              height: 0,
              id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
              language_id: 314,
              last_price: 680000,
              name: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              name_in_pos: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 2,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2019-01-25T18:36:17.6790904+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T18:31:50.3510175+03:30",
                deleted_at: null,
                description: "",
                id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
                title: "4712702618785",
                updated_at: "2018-12-12T18:31:50.3510175+03:30",
                url: "http://cs123.ir:27907/assets/images/652d936d-44e5-47d6-b264-bb0788b05fd7.png",
              }
            }
          },
          {
            active: true,
            client_id: null,
            count: 2,
            created_at: "2019-03-09T12:24:07.3545168+03:30",
            customer_id: "c47a8c6f-a649-4dbb-b7fd-af917983ebff",
            deleted_at: null,
            id: "6770145a-df8d-4ba1-9059-5199f9316c0555",
            order_id: null,
            product_id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
            updated_at: "2019-03-09T12:24:10.2636978+03:30",
            product: {
              active: true,
              all_barcode: "4712702618785;",
              app_name: "میکرو رم 16 گیگ کلاس 10",
              barcode: "4712702618785",
              brand: "سیلیکون",
              brand_id: "00000000-0000-0000-0000-000000000000",
              consumer_price: 0,
              cover_id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
              created_at: "2018-12-12T18:33:27.237578+03:30",
              current_discount: 20,
              current_price: 750000,
              deleted_at: null,
              department_code: "",
              department_id: "00000000-0000-0000-0000-000000000000",
              department_name: "",
              description: "توضیحات↵بعاد↵1 × 11 × 15 میلی‌متر↵ظرفیت↵16 گیگابایت↵استاندارد سرعت↵Class 10 , UHS-I U1↵سرعت خواندن↵40 مگابایت در ثانیه↵سرعت نوشتن↵15 مگابایت در ثانیه↵مقاوم در برابر↵ضربه↵سایر مشخصات↵- به همراه آداپتور SD",
              discount_flag: true,
              discount_group_id: "00000000-0000-0000-0000-000000000000",
              discount_group_name: "",
              external_id: "",
              gallery: null,
              height: 0,
              id: "6a0fafcf-fba1-46ab-8fc3-e77a3611f79b",
              language_id: 314,
              last_price: 680000,
              name: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              name_in_pos: "سیلیکون میکرو رم 16 گیگ کلاس 10",
              parent_id: "00000000-0000-0000-0000-000000000000",
              parent_nodes: null,
              product_type: "",
              quantity: 2,
              report_group_id: "00000000-0000-0000-0000-000000000000",
              report_group_name: "",
              reserved: 0,
              status: "",
              status_id: 243,
              stock_id: "287695d4-6fb8-49cb-b208-6b982749bc3e",
              store_id: 10,
              supplier_id: "00000000-0000-0000-0000-000000000000",
              supplier_name: "",
              tax_group_id: "00000000-0000-0000-0000-000000000000",
              tax_group_name: "",
              tax_percent: 6,
              taxable: true,
              type_id: 237,
              unit_od_measure: "",
              updated_at: "2019-01-25T18:36:17.6790904+03:30",
              weight: 0,
              width: 0,
              cover: {
                created_at: "2018-12-12T18:31:50.3510175+03:30",
                deleted_at: null,
                description: "",
                id: "652d936d-44e5-47d6-b264-bb0788b05fd7",
                title: "4712702618785",
                updated_at: "2018-12-12T18:31:50.3510175+03:30",
                url: "http://cs123.ir:27907/assets/images/652d936d-44e5-47d6-b264-bb0788b05fd7.png",
              }
            }
          },
        ]
      },
      meta: {
        store: 2
      }
    })
  )
}
